import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class InstallmentsWithNoInterest extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInstallmentsWithNoInterest);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInstallmentsWithNoInterest);
  }

  /**
   * Updates the price of installments.
   * Remember to add .js file to scripts.liquid
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInstallmentsWithNoInterest = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInstallmentsWithNoInterest = event.detail.data.html.querySelector('installments-with-no-interest');

    if (!newInstallmentsWithNoInterest) return;

    morph(this, newInstallmentsWithNoInterest, { childrenOnly: true });
  };
}

if (!customElements.get('installments-with-no-interest')) {
  customElements.define('installments-with-no-interest', InstallmentsWithNoInterest);
}
